module.exports = __webpack_public_path__ + "static/media/991988.bc5561ba.png";